import { LEADERBOARD_TIME_ZONE } from "./constants";

/**
 * The UTC instant at which the current leaderboard day began (midnight in {@link LEADERBOARD_TIME_ZONE}).
 * @param now The reference instant; defaults to the current time.
 * @returns The day's start as a Date.
 */
export function leaderboardDayStart(now: Date = new Date()): Date {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: LEADERBOARD_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value);

  const zonedAsUtc = Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"), get("second"));
  const offsetMs = zonedAsUtc - Math.floor(now.getTime() / 1000) * 1000;
  return new Date(Date.UTC(get("year"), get("month") - 1, get("day")) - offsetMs);
}

/**
 * Stable label for the leaderboard day, e.g. "2026-10-12".
 * @param now The reference instant; defaults to the current time.
 * @returns ISO-style date in {@link LEADERBOARD_TIME_ZONE}.
 */
export function leaderboardDayKey(now: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: LEADERBOARD_TIME_ZONE }).format(now);
}
